import React, { Component } from 'react';
import MultiDatePicker from '../elements/MultiDatePicker';
import moment, { Moment } from 'moment';
import { Button } from 'bloomer/lib/elements/Button';
import { errorAlert } from '../util/helperFunctions';
import styled from 'styled-components';

interface StateTypes {
  focusedInput: 'startDate' | 'endDate' | null;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}

interface PropTypes {
  handleSubmit: (startDate: Moment, endDate: Moment) => void;
}

const FlexForm = styled.form`
  display: flex;
`;

const HeightlessButton = styled(Button)`
  &.button {
    height: auto;
    height: initial;
    height: unset;
  }
`;

class DateRangeForm extends Component<PropTypes, StateTypes> {
  state = {
    startDate: moment().subtract(7, 'days'),
    endDate: moment(),
    focusedInput: null,
  };

  handleDateChange = ({
    startDate,
    endDate,
  }: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  }) => this.setState({ startDate, endDate });

  handleFocusChange = (focusedInput: StateTypes['focusedInput']) =>
    this.setState({ focusedInput });

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { handleSubmit } = this.props;
    const { startDate, endDate } = this.state;
    if (!startDate || !endDate) {
      return errorAlert('You must select both a start and an end date.');
    }

    if (endDate.isBefore(startDate)) {
      errorAlert('The end date must come after the start date.');
    }

    handleSubmit(startDate, endDate);
  };

  render() {
    const { startDate, endDate, focusedInput } = this.state;
    return (
      <FlexForm onSubmit={this.handleSubmit}>
        <MultiDatePicker
          startDate={startDate}
          endDate={endDate}
          endDateId=""
          startDateId=""
          focusedInput={focusedInput}
          onDatesChange={this.handleDateChange}
          onFocusChange={this.handleFocusChange}
          block={false}
        />
        <HeightlessButton type="submit" isColor="primary">
          Submit
        </HeightlessButton>
      </FlexForm>
    );
  }
}

export default DateRangeForm;
